import { render, staticRenderFns } from "./studyNewsList.vue?vue&type=template&id=f22ee5a2&scoped=true&"
import script from "./studyNewsList.vue?vue&type=script&lang=js&"
export * from "./studyNewsList.vue?vue&type=script&lang=js&"
import style0 from "./studyNewsList.vue?vue&type=style&index=0&id=f22ee5a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22ee5a2",
  null
  
)

export default component.exports